"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendTransaction = void 0;
const decentraland_transactions_1 = require("decentraland-transactions");
const contracts_1 = require("@ethersproject/contracts");
const eth_1 = require("../../../lib/eth");
const getTargetNetworkProvider_1 = require("./getTargetNetworkProvider");
const transactionEvents_1 = require("./transactionEvents");
const types_1 = require("./types");
const urls_1 = require("./urls");
const getProviderChainId_1 = require("./getProviderChainId");
function sendTransaction(...args) {
    return __awaiter(this, void 0, void 0, function* () {
        const [contract, contractMethodNameOrGetPopulatedTransaction, ...contractArguments] = args;
        try {
            const connectedProvider = yield (0, eth_1.getConnectedProvider)();
            if (!connectedProvider) {
                throw new Error('Provider not connected');
            }
            const chainId = yield (0, getProviderChainId_1.getProviderChainId)(connectedProvider);
            const targetNetworkProvider = yield (0, getTargetNetworkProvider_1.getTargetNetworkProvider)(contract.chainId);
            const contractInstance = new contracts_1.Contract(contract.address, contract.abi, targetNetworkProvider);
            // Populate the transaction data
            const unsignedTx = yield (typeof contractMethodNameOrGetPopulatedTransaction ===
                'function'
                ? contractMethodNameOrGetPopulatedTransaction(contractInstance.populateTransaction)
                : contractInstance.populateTransaction[contractMethodNameOrGetPopulatedTransaction](...contractArguments));
            // If the connected provider is in the target network, use it to sign and send the tx
            if (chainId === contract.chainId) {
                const signer = targetNetworkProvider.getSigner();
                const tx = yield signer.sendTransaction(unsignedTx);
                transactionEvents_1.transactionEvents.emit(types_1.TransactionEventType.SUCCESS, { txHash: tx.hash });
                return tx.hash;
            }
            else {
                // otherwise, send it as a meta tx
                const txHash = yield (0, decentraland_transactions_1.sendMetaTransaction)(connectedProvider, targetNetworkProvider, unsignedTx.data, contract, {
                    serverURL: (0, urls_1.getTransactionsApiUrl)()
                });
                transactionEvents_1.transactionEvents.emit(types_1.TransactionEventType.SUCCESS, { txHash });
                return txHash;
            }
        }
        catch (error) {
            const data = {
                type: types_1.TransactionEventType.ERROR,
                error: error
            };
            transactionEvents_1.transactionEvents.emit(types_1.TransactionEventType.ERROR, data);
            throw error;
        }
    });
}
exports.sendTransaction = sendTransaction;
//# sourceMappingURL=sendTransaction.js.map